import { ParameterConfiguration } from "./parameter-configurations";

export class ParameterGroup {

    id: number = 0;
    description!: string;
    parameterConfigurations: ParameterConfiguration[] = [];
    active: boolean = false;
    
}